<template>
  <div>
    <header class="mt-5">
      <div class="container">
        <div class="row">
          <div class="col-md-7 my-auto">
            <p class="label-top text-primary">
              PUSAKA — PANTAU SEKOLAH SMK
            </p>
            <h1>
              Pantau & laporkan sekolah anda kapanpun, dimanapun
            </h1>
            <p>
              PUSAKA atau yang disebut Pantau Sekolah SMK akan menjadi
              tempat anda untuk melaporkan kondisi sekolah anda dengan mudah
              untuk dipantau oleh Dinas Pendidikan Jawa Barat
            </p>
            <a href="/login"
               class="btn btn-primary px-5 py-2 me-2">Mulai sekarang &nbsp; →
            </a>
            <a href="#cara-lapor" class="btn btn-outline-primary px-5 py-2">
              Cara lapor
            </a>
          </div>
          <div class="col-md-5">
            <img style="width: 80%" src="/assets/images/hero-1.png" alt=""
                 class="img-fluid d-none d-lg-block d-print-block float-md-end" srcset=""/>
          </div>
        </div>
      </div>
    </header>
    <section class="about-section mt-100">
      <div class="container">
        <div class="row">
          <div class="col-md-10 mx-auto text-center">
            <p class="text-primary label-top">TENTANG PUSAKA</p>
            <h1>APA ITU PUSAKA?</h1>
            <hr width="50%" class="mx-auto" />
            <p>
              PUSAKA yang disingkat Sistem Pemantuan Sekolah berfungsi untuk
              menyambungkan pihak sekolah dengan pusat agar pemantauan dapat
              dilakukan dengan terorganisir dan mempercepat respon dari pusat
              dengan adanya laporan online. Dengan adanya PUSAKA, diharapkan
              semua sekolah dapat membuat laporan kerusakan ataupun laporan lain
              dan dapat mempermudah proses pemantuan
            </p>
            <a class="btn btn-outline-primary px-4 py-2">Baca lebih lanjut</a>
          </div>
        </div>
      </div>
    </section>
    <section class="about-section-2 mt-100">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <img src="/assets/images/body-1.png" class="img-fluid" alt="" srcset="" />
          </div>
          <div class="col-md-7 my-auto">
            <p class="text-primary label-top">
              KEMUDAHAN MENGGUNAKAN PUSAKA
            </p>
            <h1>Melapor kondisi sekolah tak pernah semudah ini</h1>
            <p>
              Dengan adanya PUSAKA, kemudahan dalam melapor kondisi sekolah
              rutin dapat dirasakan. Dengan adanya fitur laporan online,
              pemantau dapat dengan mudah menerima informasi dari sekolah yang
              sedang dilanda kerusakan/bencana dengan cepat tanpa harus datang
              ke lokasi
            </p>
            <a id="cara-lapor" href="/login">
              <p class="text-primary"
                 style="text-decoration: none"> Lapor sekarang →
              </p>
            </a>
          </div>
        </div>
      </div>
    </section>
    <section class="instruction-section mt-100">
      <div class="container">
        <div class="row">
          <div class="header-instruction text-center">
            <div class="col-md-7 mx-auto">
              <p class="text-primary label-top">
                BAGAIMANA PUSAKA BEKERJA
              </p>
              <h1>CARA PELAPORAN & PENGUNAAN</h1>
              <p>
                Untuk anda yang masih baru kenal dengan kami, kami berikan
                caranya kok dibawah bagaimana caranya untuk menggunakan aplikasi
                ini
              </p>
            </div>
          </div>
        </div>
        <div class="row flex-column-reverse flex-md-row">
          <div class="col-md-8 my-auto">
            <p class="mb-3">
              <i class="lni lni-camera icon-top bg-primary px-3 py-2 text-center"></i></p>
            <p class="text-primary label-top">LANGKAH PERTAMA</p>
            <h1 class="mt-2">
              Ambil foto bagian sekolah yang perlu
              pihak sekolah laporkan
            </h1>
            <p>
              Segera foto bagian sekolah yang terkena dampak bencana atau
              terkena dampak hal lainnya yang ingin dilaporkan dan dipantau oleh
              pusat.
            </p>
            <a href="/faq">
              <p class="text-primary" style="text-decoration: none">Selengkapnya →</p>
            </a>
          </div>
          <div class="col-md-4" data-aos="fade-up" data-aos-duration="1800">
            <img src="/assets/images/section-1.png" class="img-fluid" alt="" />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <img src="assets/images/section-2.png" class="img-fluid" alt="" />
          </div>
          <div class="col-md-8 my-auto">
            <p class="mb-3">
              <i class="lni lni-lock icon-top bg-primary px-3 py-2 text-center"></i>
            </p>
            <p class="text-primary label-top">LANGKAH KEDUA</p>
            <h1 class="mt-2">
              Login kedalam aplikasi PUSAKA dengan menekan tombol masuk di
              bagian menu
            </h1>
            <p>
              Lalu anda dapat login kedalam aplikasi kami, untuk segera
              melaporkan bagian sekolah yang ingin dilaporkan atau ingin kami
              pantau
            </p>
            <a href="/faq">
              <p class="text-primary" style="text-decoration: none">Selengkapnya →</p>
            </a>
          </div>
        </div>
        <div class="row flex-column-reverse flex-md-row">
          <div class="col-md-8 my-auto">
            <p class="mb-3"><i
              class="lni lni-upload icon-top bg-primary px-3 py-2 text-center"></i>
            </p>
            <p class="text-primary label-top">LANGKAH KETIGA</p>
            <h1 class="mt-2">
              Setelah masuk, Upload foto laporan dan isi form yang telah kami sediakan
            </h1>
            <p>
              Siapkan gambar yang telah anda ambil dan isi detail form yang
              telah kami sediakan, setelah itu data anda akan kami pantau dan
              proses!
            </p>
            <a href="/faq">
              <p class="text-primary" style="text-decoration: none"> Selengkapnya →</p>
            </a>
          </div>
          <div class="col-md-4">
            <img src="assets/images/section-3.png" class="img-fluid" alt="" />
          </div>
        </div>
      </div>
    </section>
    <section class="bonus-section mt-100">
      <div class="container">
        <div class="bg-primary card-bonus text-white p-5 rounded">
          <h1 class="fw-bold">Lakukan lebih dengan PUSAKA</h1>
          <p class="lead">Tunggu apa lagi? segera laporkan kondisi sekolah anda ke pusat untuk segera di pantau
            dan segera ditindak sesuai tindakan yang akan dilakukan</p>
          <a class="text-white" href="/login">
            Masuk &raquo;</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: 'home',
  components: {
  }
}
</script>


<style scoped>
.card-bonus {
  box-shadow: 0 1.7px 1.7px rgba(0, 0, 0, 0.011),
  0 3.9px 3.9px rgba(0, 0, 0, 0.016),
  0 6.7px 6.7px rgba(0, 0, 0, 0.02),
  0 10.3px 10.3px rgba(0, 0, 0, 0.023),
  0 15.2px 15.2px rgba(0, 0, 0, 0.027),
  0 22.3px 22.3px rgba(0, 0, 0, 0.03),
  0 33.5px 33.5px rgba(0, 0, 0, 0.034),
  0 53.4px 53.4px rgba(0, 0, 0, 0.039),
  0 100px 100px rgba(0, 0, 0, 0.05);;
}
</style>
